import { render, staticRenderFns } from "./RepairStatusBadge.vue?vue&type=template&id=3bfdeee4"
import script from "./RepairStatusBadge.vue?vue&type=script&lang=js"
export * from "./RepairStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports